import { Map } from 'immutable';

import * as constants from './../constants';

const initialState = Map({
  open: false,
  height: '38.2%', // golden ratio,
  width: '38.2%',
});

const mobileDrawerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.MOBILE_DRAWER_SHOW:
      return state.set('open', payload);
    case constants.MOBILE_DRAWER_SET_HEIGHT:
      return state.set('height', payload);
    case constants.MOBILE_DRAWER_SET_WIDTH:
      return state.set('width', payload);

    case constants.MOBILE_SESSION_STOP.SUCCESS:
      return state.set('open', false);
    default:
      return state;
  }
};

export default mobileDrawerReducer;
export { initialState };
